import type { CpapClassOption, MraAbcdScore, SptClassOption } from '@common/enums';

export enum TreatmentStatus {
    completed = 'completed',
    inProgress = 'in progress',
    stopped = 'stopped',
}

export type TreatmentData = {
    CPAP: CpapClassOption | boolean;
    lifestyle: string | boolean;
    MRA: MraAbcdScore | boolean;
    other: string | boolean;
    refer: boolean;
    SPT: SptClassOption | boolean;
};

export type ClassificationType = CpapClassOption | MraAbcdScore | SptClassOption | string | null;

export type AllTreatmentsItem = {
    classification: ClassificationType;
    endDate: string | Date | null;
    startDate: string | Date | null;
    status: TreatmentStatus;
    treatmentName: TreatmentOptionsKey;
};

export type OsasAllTreatmentsData = Array<AllTreatmentsItem>;

export type TreatmentOptionsKey = keyof TreatmentData;

export const treatmentNames: Array<TreatmentOptionsKey> = ['SPT', 'MRA', 'CPAP', 'lifestyle', 'refer', 'other'];

export type osasAllTreatmentData = {
    allTreatments: [];
};
